import { useState, useEffect } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import WhyUs from './components/WhyUs';
import Features from './components/Features';
import Menu from './components/Menu';
import Gallery from './components/Gallery';
import Location from './components/Location';
import Reservation from './components/Reservation';
import Footer from './components/Footer';

export default function Home() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen">
      <Navbar scrolled={scrolled} />
      <Hero />
      <About />
      <WhyUs />
      <Features />
      <Menu />
      <Gallery />
      <Location />
      <Reservation />
      <Footer />
    </div>
  );
}
